import { Unit } from "../@data";

export const firebaseErrorsHandler = (code: string) => {
  switch (code) {
    case "auth/user-not-found":
      return "Usuário não encontrado!";
    case "auth/wrong-password":
      return "A senha informada é inválida!";
    case "permission-denied":
      return "Você não possui permissão para realizar esta ação!";
    case "auth/too-many-requests":
      return "Você errou seu login muitas vezes, por medidas de segurança você deve tentar mais tarde!";
    default:
      return "Ocorreu um erro ao tentar processar sua requisição!";
  }
};

export const justNumbersParser = (value: string) => value.replace(/\D/g, "");

export function CPFvalidator(cpf: string | undefined) {
  if (cpf === undefined) return false;
  cpf = cpf.replace(/[^\d]/g, "");
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }
  let sum = 0;
  let rest;
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf[i - 1]) * (11 - i);
  }
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== parseInt(cpf[9])) {
    return false;
  }
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf[i - 1]) * (12 - i);
  }
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== parseInt(cpf[10])) {
    return false;
  }
  return true;
}

export const removeAccents = (str: string): string => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

type AnyObject<T> = {
  [key: string]: T;
};
export function mergeObjects<T>(
  obj1: AnyObject<T>,
  obj2: AnyObject<T>
): AnyObject<T> {
  const result: AnyObject<T> = { ...obj1 };
  for (const day in obj2) {
    if (result.hasOwnProperty(day)) {
      result[day] = { ...result[day], ...obj2[day] };
    } else {
      result[day] = obj2[day];
    }
  }
  return result;
}

export function removeObjectProperty<T>(
  obj: AnyObject<AnyObject<T>>,
  dayToRemoveProperty: string,
  propertyToRemove: string
): AnyObject<AnyObject<T>> {
  const result: AnyObject<AnyObject<T>> = { ...obj };
  if (result.hasOwnProperty(dayToRemoveProperty)) {
    const dayObject = result[dayToRemoveProperty];
    if (
      dayObject &&
      typeof dayObject === "object" &&
      dayObject.hasOwnProperty(propertyToRemove)
    ) {
      delete dayObject[propertyToRemove];
    }
  }
  return result;
}

export const formatCash = (numberParse: number): string => {
  let number = numberParse;
  let numberIsLess0 = false;
  if (number) {
    if (number < 0) {
      numberIsLess0 = true;
      number *= -1;
    }
    const numberParts =
      Number(number)?.toFixed(2)?.toString()?.split(".") ||
      0.0.toFixed(2)?.toString()?.split(".");
    numberParts[0] = numberParts[0]?.split(/(?=(?:...)*$)/).join(".");
    return `R$ ${numberParts?.join(",")}`;
  }
  return "R$ 0,00";
};

export function parseDaysWithRushHoursFromSaveDatabase(
  obj: Unit["daysWithRushHoursList"]
) {
  for (const day in obj) {
    if (obj.hasOwnProperty(day)) {
      // Itera sobre os eventos do dia
      obj[day].forEach((event) => {
        // Converte as strings de data para objetos Date
        event.startDate = new Date(event.startDate);
        event.endDate = new Date(event.endDate);
      });
    }
  }

  return obj;
}

export function isCurrentTimeBetween(
  startTime: string,
  endTime: string
): boolean {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  const [startHour, startMinutes] = startTime.split(":").map(Number);
  const [endHour, endMinutes] = endTime.split(":").map(Number);

  // Convert the times to minutes for easier comparison
  const startMinutesTotal = startHour * 60 + startMinutes;
  const endMinutesTotal = endHour * 60 + endMinutes;
  const currentMinutesTotal = currentHour * 60 + currentMinutes;

  // Check if the current time is between the provided times
  return (
    currentMinutesTotal >= startMinutesTotal &&
    currentMinutesTotal <= endMinutesTotal
  );
}
